














































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import RegNumberSearch from '@/components/RegNumberSearch.vue';
import ManualSearch from '@/components/ManualSearch.vue';
import VehicleDetail from '@/models/VehicleDetail';
import BaseServiceMixin from '../mixins/base.service.mixin';
import ConfigurationService from '../services/configuration.service';
import { getModule } from 'vuex-module-decorators';
import StoreVuexModule from '@/stores/StoreVuexModule';

@Component({
  name: 'VehicleSelection',
  components: {
    RegNumberSearch,
    ManualSearch,
  },
})
export default class VehicleSelection extends Mixins(BaseServiceMixin) {
  private gotoStep: number = 2;
  private vehicleDetail: VehicleDetail = new VehicleDetail();
  private expand: boolean[] = [false];
  private configurationService!: ConfigurationService;
  private loading: boolean = false;
  private store = getModule(StoreVuexModule, this.$store);

  public created() {
    this.configurationService = new ConfigurationService(this.axiosInstance);
  }

  private get noManualLookup(): boolean {
    return this.store.noManualLookup;
  }

  @Watch('vehicleDetail', { deep: true })
  protected async updateInternalStore() {
    let expand = true;
    if (Object.keys(this.vehicleDetail).length > 0) {
      const exist = await this.checkPatternExist();
      if (exist) {
        this.$emit('clickContinue', this.gotoStep);
        expand = false;
      } else {
        this.$emit('patternNotFound');
      }
    }
    this.expand = this.expand.map((x) => expand);
    this.$emit('selectVehicle', this.vehicleDetail);
  }

  private async checkPatternExist(): Promise<boolean> {
    let returnResult = true;
    this.loading = true;
    try {
      returnResult = await this.configurationService.GetPatternByParam({
        manufacturerId: this.vehicleDetail.makeId,
        modelGroupId: this.vehicleDetail.modelGroupId,
        modelId: this.vehicleDetail.modelId,
        generation: this.vehicleDetail.yearModel.generation,
        seatCount: this.vehicleDetail.seats,
        transmissionId: this.vehicleDetail.transmissionId,
      });
    } catch (error) {
      returnResult = false;
    } finally {
      this.loading = false;
    }
    return Promise.resolve(returnResult);
  }
}
